import { render, staticRenderFns } from "./ImportWidgetTable.vue?vue&type=template&id=b674c4de&"
import script from "./ImportWidgetTable.vue?vue&type=script&lang=js&"
export * from "./ImportWidgetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports